import styled from 'styled-components'

export const Table = styled.table`
  width: 100%;
`

export const TableRow = styled.tr`
border: 1px solid #DDD;
`

export const TableHeader = styled.th`
  border: 1px solid #DDD;
  text-align: ${(props) => 
    props.left ? 'left' : 'right'};

  padding: ${(props) => 
    props.left? '11px 0px 22px 15px' : '11px 15px 22px 0px'};

`

export const RedTableHeader = styled(TableHeader)`
  color: #d57172;
`


export const TableCell = styled.td`
  text-align: ${(props) => 
    props.left ? 'left' : 'right'};

  padding: ${(props) => 
    props.left? '11px 0px 22px 15px' : '11px 15px 22px 0px'};


  color: ${(props) => 
    props.blue ? '#4B4EA0' : props.green ? '#00C4B4' : 'inherti'};

  font-weight: ${(props) => 
    props.blue || props.green ? 'bold': ''};
`

export const PurpleTableCell = styled(TableCell)`
  color: #7f39fb;
	font-weight: bold;
`